interface isValidCoordinatesProps {
  latitude?: number | string | null;
  longitude?: number | string | null;
}

/**
 * Determines if coordinates (latitude and longitude) are valid Numbers
 * @returns true if BOTH are valid
 */
const isValidCoordinates = (
  coords?: isValidCoordinatesProps | null,
): boolean => {
  if (
    coords?.latitude !== null &&
    coords?.latitude !== undefined &&
    coords?.latitude !== '' &&
    coords?.longitude !== null &&
    coords?.longitude !== undefined &&
    coords?.longitude !== ''
  ) {
    return true;
  }
  return false;
};

export default isValidCoordinates;
